import React from "react";

import TextAreaWithButton from "./Common/TextAreaWithButton";

const BusinessRules = () => {
  const handleSystemDataEntry = text => logger.info({ text });
  return (
    <div className="dsde-business-rules__wrapper">
      <TextAreaWithButton
        title="System Data Entry Edits"
        handleSave={handleSystemDataEntry}
      />
      <TextAreaWithButton
        title="Recurring Data Quality Issues"
        handleSave={handleSystemDataEntry}
      />
      <TextAreaWithButton
        title="Validation Rules and Error Reports"
        handleSave={handleSystemDataEntry}
      />
      <TextAreaWithButton
        title="Security Rules"
        handleSave={handleSystemDataEntry}
      />
    </div>
  );
};

export default BusinessRules;
